import { INTEGRATIONS_SLACK_CONFIGURATION } from '../../../../routes';
import { preventJavascriptUrls } from '../../../../services/security';
import { DeprecatedButtonContainer } from '../../../components/ButtonContainer';
import { Grid, GridItem } from '../../../components/Grid';
import ImageWithAspectRatio from '../../../components/ImageWithAspectRatio';
import Link from '../../../components/Link';
import Modal from '../../../components/Modal';
import { prependAppPath } from '../../../services/Url';
import styles from './style.m.less';

export default function ChatPromotionModal({ isOpen, onClose }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ChatDescription
                title="Keep the conversation going"
                screenshot={require('./slack-ui.png')}
                href={prependAppPath(INTEGRATIONS_SLACK_CONFIGURATION)}
                label="Configure Slack"
                width={543}
                height={343}
            >
                <p>
                    Managers stay up-to-date with the latest objectives created by their teams. Employees shine with
                    Praise that is easy to send and visible right in Slack. And the difference between a fast, helpful
                    feedback talk and barely remembering what happened since the last one is just a private /note away.
                </p>
                <p>
                    <Link
                        href="https://intercomdocs.small-improvements.com/en/articles/9151041-slack-integration"
                        openInNewTab={true}
                    >
                        Learn more in our documentation.
                    </Link>
                </p>
            </ChatDescription>
        </Modal>
    );
}

function ChatDescription({ title, href, label, screenshot, children, width, height }) {
    return (
        <div>
            <h1>{title}</h1>
            <Grid>
                <GridItem desktop="half" s="full">
                    {children}
                </GridItem>
                <GridItem desktop="half" s="full">
                    <ImageWithAspectRatio
                        width={width}
                        height={height}
                        className={styles.screenshot}
                        src={screenshot}
                    />
                </GridItem>
            </Grid>

            <DeprecatedButtonContainer>
                <a className="button save" href={preventJavascriptUrls(href)}>
                    {label}
                </a>
            </DeprecatedButtonContainer>
        </div>
    );
}
